import ModalEditUnclearAnswers from '@/components/modal-edit-unclear-answers/modal-edit-unclear-answers';
import {
  Box,
  IconArrowRight,
  Link,
  LinkSize,
  ProgressBar,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@cmpsr/components';

type InaccurateAssessmentProps = {
  assessmentProgress?: number;
  text: string;
};

function useLinkSize(): LinkSize {
  return useBreakpointValue({ base: 'm', xl: 'l' }, { ssr: false }) ?? 'm';
}

export default function InaccurateAssessment({ assessmentProgress = 0, text }: InaccurateAssessmentProps) {
  const {
    isOpen: showModalEditUnclearAnswers,
    onOpen: onShowModalEditUnclearAnswers,
    onClose: onHideModalEditUnclearAnswers,
  } = useDisclosure();
  const linkSize = useLinkSize();

  return (
    <Box
      px={{ base: 'spacer-6', xl: 'spacer-8' }}
      py={{ base: 'spacer-6', xl: 'spacer-9' }}
      borderRadius="radii-4"
      backgroundColor="alert-warning-default"
    >
      <Text variant="text-header-XS" textTransform="uppercase" mb="spacer-2">
        almost done!
      </Text>
      <Text variant="text-header-XL" mb="spacer-4">{`${assessmentProgress}%`}</Text>
      <ProgressBar
        size="xs"
        mb={{ base: 'spacer-4', xl: 'spacer-5' }}
        min={0}
        max={100}
        value={assessmentProgress}
        variant="defaultColor"
      />
      <Text variant="text-body-regular" mb={{ base: 'spacer-5', xl: 'spacer-6' }}>
        {text}
      </Text>
      <Link
        role="button"
        onClick={onShowModalEditUnclearAnswers}
        variant="primary"
        size={linkSize}
        trailingIcon={<IconArrowRight />}
        justifyContent="center"
        width="auto"
      >
        Complete Assessment
      </Link>
      <ModalEditUnclearAnswers isOpen={showModalEditUnclearAnswers} onCloseClick={onHideModalEditUnclearAnswers} />
    </Box>
  );
}
